import Button from "@material-ui/core/Button";
import DynamicForm from "Component/DynamicForm";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { instance } from "Actions/AxiosInstance";
import { getFormattedImageLink } from "Utils";
import moment from "moment";
import CallOutNew from "Component/Headers/callOutNew";

export class Feedback extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      imagepath: "",
      audienceId: "1",
      isPrivateNote: true,
      feedbackdata: [],
      feedback: "",
      feedbackscoreid: null,
      ratingScale: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" },
        { value: "6" },
        { value: "7" },
        { value: "8" },
        { value: "9" },
        { value: "10" },
      ],
    };

    this.handleChange = this.handleChange.bind(this);
    this.addFeedback = this.addFeedback.bind(this);
  }

  componentDidMount() {
    this.getFeedback();
  }

  getFeedback() {
    const data = {
      candidateid: this.props.candidateid,
      ishistory: true,
    };
    const URL = `recruit/getcandidatefeedback`;
    instance
      .post(URL, data)
      .then((result) => {
        this.setState({
          feedbackdata: result.data.result,
        });
        // this.props.enqueueSnackbar("Saved successfully", { variant: 'success' });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  handleChange(key, value) {
    this.setState({ [key]: value });
  }

  addFeedback() {
    const data = {
      candidateid: this.props.candidateid,
      pipelinestageid: this.props.pipelinestageid,
      feedbackscoreid: this.state.feedbackscoreid,
      feedbackpoint: this.state.feedbackscoreid,
      feedback: this.state.feedback,
    };
    const URL = `recruit/insertupdatecandidatefeedback`;
    this.setState({
      isDisableSaveButton: true,
    });
    instance
      .post(URL, data)
      .then((result) => {
        this.getFeedback();
        this.setState({
          feedback: "",
          feedbackscoreid: null,
          isDisableSaveButton: false
        });
        this.props.enqueueSnackbar("feedback updated successfully", {
          variant: "success",
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
        this.setState({
          isDisableSaveButton: false,
        });
      });
  }

  render() {
    const { feedbackdata } = this.state;

    return (
      <div>
        <p className="small-dark">
          How likely are you to recommend hiring{" "}
          <strong> {this.props.candidateDetails[0].name} </strong> for the
          position of {this.props.candidateDesignation}?
        </p>
        <div className="display-flex margin-top-16">
          <p className="extra-small-dark-disabled margin-right-8 margin-top-4">
            Not at all likely
          </p>
          <div>
            {this.state.ratingScale.map((x) => (
              <div
                className={
                  x.value == this.state.feedbackscoreid
                    ? "rating-scale-points feedback-selected"
                    : "rating-scale-points"
                }
                onClick={() => this.handleChange("feedbackscoreid", x.value)}
              >
                <span>{x.value}</span>
              </div>
            ))}

            <div className="clear-float"></div>
          </div>
          <p className="extra-small-dark-disabled margin-right-8 margin-top-4">
            Extremely likely
          </p>
        </div>

        <div className="margin-top-24">
          <p className="small-dark">
            Please write your detailed analysis based on the above scores
          </p>
          <div style={{ width: 350 }}>
            <DynamicForm
              fields={textareainputconverter({
                value: this.state.feedback,
                label: "",
                placeholder: "",
                disabled: this.props.candidateempid ? true : false,
              })}
              onChange={(e) => this.handleChange("feedback", e)}
            />
          </div>
          <Button
            className={
              this.props.candidateempid
                ? "btn btn-primary-md-grey margin-bottom-16"
                : "btn btn-primary-md-blue margin-bottom-16"
            }
            variant="contained"
            onClick={this.addFeedback}
            disabled={this.state.isDisableSaveButton || this.props.candidateempid ? true : false}
          >
            Add feedback
          </Button>
          <div classnames="margin-top-16 margin-bottom-16">
            <CallOutNew
              classnames="bg-light-blue"
              header="Latest feedback will be consider in case of multiple feedback added by one person"
              emoji="📌"
              textcolor="#1e8ced"
            />
          </div>
        </div>

        <div className="dashed-divider1 position-rel text-center clear-float">
          <span
            style={{
              background: "#fff",
              position: "relative",
              top: -14,
              padding: "0px 24px",
            }}
            className="extra-small-dark-secondary"
          >
            Feedback history
          </span>
        </div>
        {feedbackdata &&
          feedbackdata.map((x) => (
            <div className="rounded-rectangle-div display-flex margin-bottom-16">
              <div className="margin-right-16">
                <ProfilePicture
                  src={getFormattedImageLink(this.state.imagepath)}
                  height="40"
                />
              </div>

              <div>
                <p className="extra-small-dark-secondary inline-block">
                  {x.fullname} on {moment(x.updateddate).format("YYYY-MM-DD")}{" "}
                  &nbsp;• {x.stagename}
                </p>
                <div className="margin-top-8">
                  {this.state.ratingScale.map((x1) => (
                    <div
                      className={
                        x1.value == x.feedbackscoreid
                          ? "rating-scale-points1  feedback-selected"
                          : "rating-scale-points1"
                      }
                      // onClick={() =>
                      //   this.handleChange1("weightagetypeid", x.displayvalue)
                      // }
                    >
                      <span>{x1.value}</span>
                    </div>
                  ))}
                  <div className="clear-float"></div>
                </div>
                <p className="small-dark-secondary margin-top-8">
                  {x.feedback}
                </p>
              </div>
            </div>
          ))}
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(withSnackbar(Feedback));
